<template>
  <popup :opened="dataToShow" @close="changeToShow(false)">
    <message-header :message-header="messageHeader" />

    <div class="sticky top-0 z-10">
      <!-- Save button -->
      <div
        v-if="saving"
        class="absolute w-14 h-14 right-1 mt-13 mr-13 rounded-full cursor-pointer bg-pink-600 hover:shadow-pink text-white"
      >
        <span class="h-6 w-6 ml-4 mt-1/4 spinner spinner-save" />
      </div>
      <div
        v-else
        class="absolute w-14 h-14 right-1 mt-13 mr-13 rounded-full cursor-pointer bg-pink-600 hover:shadow-pink text-white"
        @click.stop="saveRole"
      >
        <icon class="h-6 w-6 ml-4 mt-1/4" name="save" />
      </div>
    </div>

    <!-- BEGIN Content MODAL add role -->
    <div class="m-5 lg:m-15 2xl:m-20">
      <h3 v-if="isNewRole" class="mb-15">Ajouter un nouveau rôle</h3>
      <h3 v-else class="mb-15">
        Modifier les droits d'accès <br />du rôle "{{ roleToEdit.name }}"
      </h3>

      <!-- BEGIN inputs name and description -->
      <div class="w-full mb-15">
        <div class="grid grid-cols-2 justify-center gap-x-0 md:gap-x-4">
          <div class="col-span-full sm:col-span-1">
            <input-text
              @click="SET_ERRORS(null)"
              name="name"
              libelle="Nom du rôle"
              :value="roleToEdit.name"
              @input="
                (newValue) => {
                  $set(roleToEdit, 'name', newValue);
                }
              "
              class="mr-4"
            />
          </div>
          <div class="col-span-full sm:col-span-1">
            <input-text
              name="description"
              libelle="Description"
              :value="roleToEdit.description"
              @input="
                (newValue) => {
                  $set(roleToEdit, 'description', newValue);
                }
              "
            />
          </div>
        </div>
        <v-errors
          :errors="{ ...errors }"
          class="text-sm font-medium text-red-500 w-full"
        />
      </div>
      <!-- END inputs name and description -->

      <div class="w-full text-left text-pink-600 text-lg mb-15">
        DROITS ET RESTRICTIONS
      </div>

      <!-- BEGIN list of permissions per group -->
      <!-- First group is for neopass form permissions -->
      <div class="odd:bg-indigo-100 odd:bg-opacity-50 w-full">
        <!-- BEGIN Informations on accordion -->
        <div
          id="accordion_neopass_form"
          class="h-16 lg:h-24 2xl:h-32 cursor-default hover:bg-indigo-200 grid grid-cols-12 gap-x-4 place-content-center"
          :class="{
            'bg-indigo-200 border-l-2 border-indigo-600':
              groupPermissionsDisplay == constants.PERMISSION_NEOPASS_FORM_PAGE,
          }"
          @click="
            displayGroupPermissions(constants.PERMISSION_NEOPASS_FORM_PAGE)
          "
        >
          <div class="col-span-1 text-pink-600 place-self-center">
            <icon
              class="inline-block transform transition-transform ease-in-out duration-300"
              :class="{
                'rotate-90':
                  groupPermissionsDisplay ==
                  constants.PERMISSION_NEOPASS_FORM_PAGE,
              }"
              name="chevron-right"
            />
          </div>
          <div class="col-span-11 w-full text-base">
            Formulaire carnet de parcours
          </div>
        </div>
        <!-- END Informations on accordion -->
        <transition
          enter-active-class="ease-out duration-300"
          enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          enter-to-class="opacity-100 translate-y-0 sm:scale-100"
          leave-active-class="ease-in duration-200"
          leave-class="opacity-100 translate-y-0 sm:scale-100"
          leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        >
          <!-- BEGIN Form content -->
          <div
            v-if="
              groupPermissionsDisplay == constants.PERMISSION_NEOPASS_FORM_PAGE
            "
            class="w-full bg-white grid grid-cols-2 justify-start pt-10"
          >
            <div class="col-span-full sm:col-span-1">
              <div
                v-if="
                  listNeopassModulesPages.filter((m) =>
                    permissions.includes(m.name + '_read')
                  ).length > 0
                "
              >
                <checkbox-indigo
                  name="Lecture"
                  libelle="LECTURE"
                  color-libelle="indigo-600"
                  :value="
                    (
                      (((roleToEdit || {}).rights || {}).neopassForm || {})
                        .read || {}
                    ).all
                  "
                  @input="
                    (newValue) => {
                      (
                        (((roleToEdit || {}).rights || {}).neopassForm || {})
                          .read || {}
                      ).all = newValue;

                      checkallNeopassForm('read', 'all', newValue);

                      if (!newValue) {
                        (
                          (((roleToEdit || {}).rights || {}).neopassForm || {})
                            .edit || {}
                        ).all = newValue;
                        checkallNeopassForm('edit', 'all', newValue);
                      }
                    }
                  "
                  class="text-indigo-600"
                  size-libelle="text-base"
                />
              </div>
              <div
                v-for="(mod, numMod) in listNeopassModulesPages.filter((m) =>
                  permissions.includes(m.name + '_read')
                )"
                :key="numMod"
                class="m-3"
              >
                <div>
                  <checkbox-indigo
                    :name="mod.name"
                    :libelle="mod.display_name"
                    :value="
                      (
                        ((((roleToEdit || {}).rights || {}).neopassForm || {})
                          .read || {})[mod.name] || {}
                      ).all
                    "
                    @input="
                      (newValue) => {
                        (
                          ((((roleToEdit || {}).rights || {}).neopassForm || {})
                            .read || {})[mod.name] || {}
                        ).all = newValue;
                        checkallNeopassForm('read', mod.name, newValue);
                        decheckallNeopassForm('read', mod.name, newValue);
                        if (!newValue) {
                          (
                            ((
                              ((roleToEdit || {}).rights || {}).neopassForm ||
                              {}
                            ).edit || {})[mod.name] || {}
                          ).all = newValue;
                          checkallNeopassForm('edit', mod.name, newValue);
                          decheckallNeopassForm('edit', mod.name, newValue);
                        }
                      }
                    "
                    class="mb-1.5"
                    size-libelle="text-base"
                  />
                </div>

                <div
                  v-for="(page, numPage) in mod.pages.filter(
                    (p) =>
                      permissions.includes(p.name + '_read') &&
                      p.name != constants.PAGE_NEOPASS_FORM_DOCUMENTS
                  )"
                  :key="numPage"
                >
                  <checkbox-indigo
                    :name="page.name"
                    :libelle="page.display_name"
                    color-libelle="gray-600"
                    :value="
                      (((((roleToEdit || {}).rights || {}).neopassForm || {})
                        .read || {})[mod.name] || {})[page.name]
                    "
                    @input="
                      (newValue) => {
                        (((((roleToEdit || {}).rights || {}).neopassForm || {})
                          .read || {})[mod.name] || {})[page.name] = newValue;
                        decheckallNeopassForm('read', mod.name, newValue);
                        if (!newValue) {
                          (((
                            ((roleToEdit || {}).rights || {}).neopassForm || {}
                          ).edit || {})[mod.name] || {})[page.name] = newValue;
                          decheckallNeopassForm('edit', mod.name, newValue);
                        }
                      }
                    "
                    class="text-gray-600"
                    size-libelle="text-base"
                    weight-libelle="font-light"
                  />
                </div>
                <checkbox-indigo
                  v-if="permissions.includes(mod.name + '_auto_eval_read')"
                  :name="mod.name + '_auto_eval_read'"
                  libelle="Auto Evaluation Bénéficiaire"
                  color-libelle="gray-600"
                  :value="
                    (((((roleToEdit || {}).rights || {}).neopassForm || {})
                      .read || {})[mod.name] || {})['auto_eval']
                  "
                  @input="
                    (newValue) => {
                      (((((roleToEdit || {}).rights || {}).neopassForm || {})
                        .read || {})[mod.name] || {})['auto_eval'] = newValue;
                      decheckallNeopassForm('read', mod.name, newValue);
                      if (!newValue) {
                        (((((roleToEdit || {}).rights || {}).neopassForm || {})
                          .edit || {})[mod.name] || {})['auto_eval'] = newValue;
                        decheckallNeopassForm('edit', mod.name, newValue);
                      }
                    }
                  "
                  class="text-gray-600"
                  size-libelle="text-base"
                  weight-libelle="font-light"
                />
              </div>
            </div>
            <div class="col-span-full sm:col-span-1">
              <div
                v-if="
                  listNeopassModulesPages.filter((m) =>
                    permissions.includes(m.name + '_edit')
                  ).length > 0
                "
              >
                <checkbox-indigo
                  name="Ecriture"
                  libelle="ECRITURE"
                  color-libelle="indigo-600"
                  :value="
                    (
                      (((roleToEdit || {}).rights || {}).neopassForm || {})
                        .edit || {}
                    ).all
                  "
                  @input="
                    (newValue) => {
                      (
                        (((roleToEdit || {}).rights || {}).neopassForm || {})
                          .edit || {}
                      ).all = newValue;
                      checkallNeopassForm('edit', 'all', newValue);
                      if (newValue) {
                        (
                          (((roleToEdit || {}).rights || {}).neopassForm || {})
                            .read || {}
                        ).all = newValue;
                        checkallNeopassForm('read', 'all', newValue);
                      }
                    }
                  "
                  class="w-1/2 text-indigo-600"
                  size-libelle="text-base"
                />
              </div>
              <div
                v-for="(mod, numMod) in listNeopassModulesPages.filter((m) =>
                  permissions.includes(m.name + '_edit')
                )"
                :key="numMod"
                class="m-3"
              >
                <div>
                  <checkbox-indigo
                    :name="mod.name"
                    :libelle="mod.display_name"
                    :value="
                      (
                        ((((roleToEdit || {}).rights || {}).neopassForm || {})
                          .edit || {})[mod.name] || {}
                      ).all
                    "
                    @input="
                      (newValue) => {
                        (
                          ((((roleToEdit || {}).rights || {}).neopassForm || {})
                            .edit || {})[mod.name] || {}
                        ).all = newValue;
                        checkallNeopassForm('edit', mod.name, newValue);
                        decheckallNeopassForm('edit', mod.name, newValue);
                        if (newValue) {
                          (
                            ((
                              ((roleToEdit || {}).rights || {}).neopassForm ||
                              {}
                            ).read || {})[mod.name] || {}
                          ).all = newValue;
                          checkallNeopassForm('read', mod.name, newValue);
                        }
                      }
                    "
                    class="mb-1.5"
                    size-libelle="text-base"
                  />
                </div>
                <span
                  v-for="(page, numPage) in mod.pages.filter(
                    (p) =>
                      permissions.includes(p.name + '_edit') &&
                      p.name != constants.PAGE_NEOPASS_FORM_DOCUMENTS
                  )"
                  :key="numPage"
                >
                  <checkbox-indigo
                    :name="page.name"
                    :libelle="page.display_name"
                    color-libelle="gray-600"
                    :value="
                      (((((roleToEdit || {}).rights || {}).neopassForm || {})
                        .edit || {})[mod.name] || {})[page.name]
                    "
                    @input="
                      (newValue) => {
                        (((((roleToEdit || {}).rights || {}).neopassForm || {})
                          .edit || {})[mod.name] || {})[page.name] = newValue;
                        decheckallNeopassForm('edit', mod.name, newValue);
                        if (newValue) {
                          (((
                            ((roleToEdit || {}).rights || {}).neopassForm || {}
                          ).read || {})[mod.name] || {})[page.name] = newValue;
                        }
                      }
                    "
                    class="text-gray-600"
                    size-libelle="text-base"
                    weight-libelle="font-light"
                  />
                </span>
                <checkbox-indigo
                  v-if="permissions.includes(mod.name + '_auto_eval_edit')"
                  :name="mod.name + '_auto_eval_edit'"
                  libelle="Auto Evaluation Bénéficiaire"
                  color-libelle="gray-600"
                  :value="
                    (((((roleToEdit || {}).rights || {}).neopassForm || {})
                      .edit || {})[mod.name] || {})['auto_eval']
                  "
                  @input="
                    (newValue) => {
                      (((((roleToEdit || {}).rights || {}).neopassForm || {})
                        .edit || {})[mod.name] || {})['auto_eval'] = newValue;
                      decheckallNeopassForm('edit', mod.name, newValue);
                      if (newValue) {
                        (((((roleToEdit || {}).rights || {}).neopassForm || {})
                          .read || {})[mod.name] || {})['auto_eval'] = newValue;
                      }
                    }
                  "
                  class="text-gray-600"
                  size-libelle="text-base"
                  weight-libelle="font-light"
                />
              </div>
            </div>
          </div>
          <!-- END Form content -->
        </transition>
      </div>

      <!-- Then, there are other modules -->
      <div
        v-for="(group, num_grp) in filteredListPermissions"
        :key="num_grp"
        class="odd:bg-indigo-100 odd:bg-opacity-50"
      >
        <!-- BEGIN Informations on accordion -->
        <div
          :id="'accordion_' + group.module"
          class="h-16 lg:h-24 2xl:h-32 cursor-default hover:bg-indigo-200 grid grid-cols-12 gap-x-4 place-content-center"
          :class="{
            'bg-indigo-200 border-l-2 border-indigo-600':
              groupPermissionsDisplay == group.module,
          }"
          @click="displayGroupPermissions(group.module)"
        >
          <div class="col-span-1 text-pink-600 place-self-center">
            <icon
              class="inline-block transform transition-transform ease-in-out duration-300"
              :class="{
                'rotate-90': groupPermissionsDisplay == group.module,
              }"
              name="chevron-right"
            />
          </div>
          <div
            class="col-span-11 text-base place-self-center justify-self-start"
          >
            {{ group.display_name }}
          </div>
        </div>
        <!-- END Informations on accordion -->
        <transition
          enter-active-class="ease-out duration-300"
          enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          enter-to-class="opacity-100 translate-y-0 sm:scale-100"
          leave-active-class="ease-in duration-200"
          leave-class="opacity-100 translate-y-0 sm:scale-100"
          leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        >
          <!-- BEGIN Form content -->
          <div
            v-if="groupPermissionsDisplay == group.module"
            class="bg-white grid grid-cols-2 gap-x-4 gap-y-5 py-5"
          >
            <div class="col-span-full">
              <checkbox-indigo
                name="tout"
                :libelle="getLibelle(group)"
                color-libelle="indigo-600"
                :value="
                  (((roleToEdit || {}).rights || {})[group.module] || {}).all
                "
                @input="
                  (newValue) => {
                    (
                      ((roleToEdit || {}).rights || {})[group.module] || {}
                    ).all = newValue;
                    checkallModule(group.module, newValue);
                  }
                "
                size-libelle="text-base"
              />
            </div>
            <div
              v-for="(func, num_func) in filterPermissions(group)"
              :key="num_func"
              class="col-span-full sm:col-span-1"
            >
              <checkbox-indigo
                :name="func.name"
                :libelle="func.display_name"
                color-libelle="indigo-600"
                :value="
                  (((roleToEdit || {}).rights || {})[group.module] || {})[
                    func.name
                  ]
                "
                @input="
                  (newValue) => {
                    (((roleToEdit || {}).rights || {})[group.module] || {})[
                      func.name
                    ] = newValue;
                    decheckallModule(group.module, newValue);
                  }
                "
                size-libelle="text-base"
              />
            </div>
            <!-- BEGIN Special FICHE DE POSTE module => Bibliothèque de fiches de poste personnelles -->
            <div
              v-if="
                [
                  constants.MODULE_FICHE_DE_POSTE,
                  constants.MODULE_REFERENTIEL_FORMATION,
                ].includes(group.module)
              "
              class="col-span-full grid grid-cols-2 gap-x-4 gap-y-5 self-start"
            >
              <div class="col-span-full">
                <checkbox-indigo
                  name="tout_personnal_library"
                  libelle="Tout dans bibliothèque personnelle"
                  color-libelle="indigo-600"
                  :value="
                    (((roleToEdit || {}).rights || {})[group.module] || {})
                      .allPersonnal
                  "
                  @input="
                    (newValue) => {
                      (
                        ((roleToEdit || {}).rights || {})[group.module] || {}
                      ).allPersonnal = newValue;
                      if (group.module === constants.MODULE_FICHE_DE_POSTE)
                        checkAllFicheDePostePersonnalLibrary(newValue);
                      if (
                        group.module === constants.MODULE_REFERENTIEL_FORMATION
                      )
                        checkAllReferentielFormationPersonnalLibrary(newValue);
                      decheckallModule(group.module, newValue);
                    }
                  "
                  size-libelle="col-span-1 text-base mb-3"
                />
              </div>

              <div
                v-for="(func, num_func) in listPermissions.filter(
                  (p) =>
                    p.module == group.module &&
                    [
                      constants.MODULE_FICHE_DE_POSTE,
                      constants.MODULE_REFERENTIEL_FORMATION,
                    ].includes(p.module) &&
                    p.type == 'function' &&
                    ((p.module === constants.MODULE_FICHE_DE_POSTE &&
                      p.name.includes('job_description_personnal')) ||
                      (p.module === constants.MODULE_REFERENTIEL_FORMATION &&
                        p.name.includes('ref_formations_personnal'))) &&
                    ![
                      constants.PERMISSION_FICHE_DE_POSTE_PERSONNELLE_LISTE,
                      constants.PERMISSION_REFERENTIEL_FORMATION_PERSONNELLE_LISTE,
                    ].includes(p.name)
                )"
                :key="num_func"
                class="col-span-full sm:col-span-1"
              >
                <checkbox-indigo
                  class="truncate"
                  :name="func.name"
                  :libelle="func.display_name"
                  color-libelle="indigo-600"
                  :value="
                    (((roleToEdit || {}).rights || {})[group.module] || {})[
                      func.name
                    ]
                  "
                  @input="
                    (newValue) => {
                      (((roleToEdit || {}).rights || {})[group.module] || {})[
                        func.name
                      ] = newValue;
                      if (p.module === constants.MODULE_FICHE_DE_POSTE)
                        decheckAllFicheDePostePersonnalLibrary(newValue);
                      if (p.module === constants.MODULE_REFERENTIEL_FORMATION)
                        decheckAllReferentielFormationPersonnalLibrary(
                          newValue
                        );
                      decheckallModule(group.module, newValue);
                    }
                  "
                  size-libelle="text-base"
                />
              </div>
            </div>
            <!-- END Special FICHE DE POSTE module => Bibliothèque de fiches de poste personnelles -->
            <!-- BEGIN Special FICHE DE POSTE module => Bibliothèque de fiches de poste communes -->
            <div
              v-if="
                [
                  constants.MODULE_FICHE_DE_POSTE,
                  constants.MODULE_REFERENTIEL_FORMATION,
                ].includes(group.module)
              "
              class="col-span-full grid grid-cols-2 gap-x-4 gap-y-5 self-start"
            >
              <div class="col-span-full">
                <checkbox-indigo
                  name="tout_shared_library"
                  libelle="Tout dans bibliothèque commune"
                  color-libelle="indigo-600"
                  :value="
                    (((roleToEdit || {}).rights || {})[group.module] || {})
                      .allShared
                  "
                  @input="
                    (newValue) => {
                      (
                        ((roleToEdit || {}).rights || {})[group.module] || {}
                      ).allShared = newValue;
                      if (group.module === constants.MODULE_FICHE_DE_POSTE)
                        checkAllFicheDePosteSharedLibrary(newValue);
                      if (
                        group.module === constants.MODULE_REFERENTIEL_FORMATION
                      )
                        checkAllReferentielFormationSharedLibrary(newValue);
                      decheckallModule(group.module, newValue);
                    }
                  "
                  size-libelle="col-span-1 text-base mb-3"
                />
              </div>

              <div
                v-for="(func, num_func) in listPermissions.filter(
                  (p) =>
                    p.module == group.module &&
                    [
                      constants.MODULE_FICHE_DE_POSTE,
                      constants.MODULE_REFERENTIEL_FORMATION,
                    ].includes(p.module) &&
                    p.type == 'function' &&
                    ((p.module === constants.MODULE_FICHE_DE_POSTE &&
                      p.name.includes('job_description_shared')) ||
                      (p.module === constants.MODULE_REFERENTIEL_FORMATION &&
                        p.name.includes('ref_formations_shared'))) &&
                    ![
                      constants.PERMISSION_FICHE_DE_POSTE_COMMUNE_LISTE,
                      constants.PERMISSION_REFERENTIEL_FORMATION_COMMUNE_LISTE,
                    ].includes(p.name)
                )"
                :key="num_func"
                class="col-span-full sm:col-span-1"
              >
                <checkbox-indigo
                  class="truncate"
                  :name="func.name"
                  :libelle="func.display_name"
                  color-libelle="indigo-600"
                  :value="
                    (((roleToEdit || {}).rights || {})[group.module] || {})[
                      func.name
                    ]
                  "
                  @input="
                    (newValue) => {
                      (((roleToEdit || {}).rights || {})[group.module] || {})[
                        func.name
                      ] = newValue;
                      if (p.module === constants.MODULE_FICHE_DE_POSTE)
                        decheckAllFicheDePosteSharedLibrary(newValue);
                      if (p.module === constants.MODULE_REFERENTIEL_FORMATION)
                        decheckAllReferentielFormationSharedLibrary(newValue);
                      decheckallModule(group.module, newValue);
                    }
                  "
                  size-libelle="text-base"
                />
              </div>
            </div>
            <!-- END Special FICHE DE POSTE module => Bibliothèque de fiches de poste communes -->
          </div>
          <!-- END Form content -->
        </transition>
      </div>
      <!-- END list of permissions per group -->
    </div>
    <!-- END Content MODAL add role -->
  </popup>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import Popup from './../../../components/Popup';
import MessageHeader from './../../../components/MessageHeader';
import Icon from './../../../components/Icon';
import InputText from './../../../components/Inputs/InputText';
import CheckboxIndigo from './../../../components/Inputs/CheckboxIndigo';
import Constants from './../../../constants';

export default {
  name: 'EditRolePopup',

  props: {
    dataToShow: Boolean,
    isNewRole: Boolean,
  },

  data() {
    return {
      groupPermissionsDisplay: '',
      notDisplayedModules: ['dashboard', 'menu', 'neopass', 'neopass_form'],
      constants: Constants,
    };
  },

  components: {
    Popup,
    MessageHeader,
    Icon,
    InputText,
    CheckboxIndigo,
  },

  computed: {
    ...mapGetters({
      saving: 'permissions/saving',
      messageHeader: 'permissions/messageHeader',
      roleToEdit: 'roles/roleToEdit',
      listNeopassModulesPages: 'permissions/listNeopassModulesPages',
      listPermissions: 'permissions/listPermissions',
      errors: 'permissions/errors',
      permissions: 'auth/permissions',
    }),

    filteredListPermissions() {
      return this.listPermissions.filter(
        (p) => p.type == 'page' && !this.notDisplayedModules.includes(p.module)
      );
    },
  },

  methods: {
    ...mapActions({
      saveRole: 'roles/saveRole',
    }),

    ...mapMutations({
      SET_ERRORS: 'permissions/SET_ERRORS',
    }),

    getLibelle(group) {
      const simpleModules = [
        Constants.MODULE_RECHERCHE_COMPETENCES,
        Constants.MODULE_DEPOT_DOCUMENTS,
        Constants.PERMISSION_AIDE_PAGE,
        Constants.MODULE_COMPETENCES,
      ];

      if (simpleModules.includes(group.module)) {
        return 'Accès au module';
      }

      return 'Tout';
    },

    filterPermissions(group) {
      const inCurrentModule = (p) => p.module === group.module;
      const isFunction = (p) => p.type === 'function';
      const isNotFicheDePoste = (p) =>
        p.module !== Constants.MODULE_FICHE_DE_POSTE;
      const isNotReferentielFormation = (p) =>
        p.module !== Constants.MODULE_REFERENTIEL_FORMATION;
      const isNotDepotDocuments = (p) =>
        p.module !== Constants.MODULE_DEPOT_DOCUMENTS;
      const isNotHelpPage = (p) => p.module !== Constants.PERMISSION_AIDE_PAGE;

      return this.listPermissions
        .filter(inCurrentModule)
        .filter(isNotFicheDePoste)
        .filter(isNotReferentielFormation)
        .filter(isNotDepotDocuments)
        .filter(isNotHelpPage)
        .filter(isFunction);
    },

    changeToShow(val) {
      this.$emit('showChange', val);
      this.groupPermissionsDisplay = '';
      this.SET_ERRORS(null);
    },

    displayGroupPermissions(groupName) {
      if (this.groupPermissionsDisplay == groupName) {
        this.groupPermissionsDisplay = '';
      } else {
        this.groupPermissionsDisplay = groupName;
        let pos = document.getElementById('accordion_' + groupName);
        setTimeout(() => {
          pos.scrollIntoView({ block: 'start' });
        }, 300);
      }
    },

    /* BEGIN Boutons "Tout" dans le module formulaire Neopass (Ecriture / lecture / par module) */
    checkallNeopassForm(readOrEdit, moduleName, state) {
      if (moduleName == 'all') {
        for (let mod in this.roleToEdit.rights.neopassForm[readOrEdit]) {
          if (mod != 'all') {
            for (var page in this.roleToEdit.rights.neopassForm[readOrEdit][
              mod
            ]) {
              this.roleToEdit.rights.neopassForm[readOrEdit][mod][page] = state;
            }

            // right for evaluation auto
            if (this.permissions.includes(mod + '_auto_eval_' + readOrEdit)) {
              this.roleToEdit.rights.neopassForm[readOrEdit][mod]['auto_eval'] =
                state;
            }
          }
        }
      } else {
        for (var page in this.roleToEdit.rights.neopassForm[readOrEdit][
          moduleName
        ]) {
          if (page != 'all') {
            this.roleToEdit.rights.neopassForm[readOrEdit][moduleName][page] =
              state;
          }
        }

        // right for evaluation auto
        if (
          this.permissions.includes(moduleName + '_auto_eval_' + readOrEdit)
        ) {
          this.roleToEdit.rights.neopassForm[readOrEdit][moduleName][
            'auto_eval'
          ] = state;
        }
      }
    },

    //To decheck checkbox LECTURE or ECRITURE or module linked with page's checkbox
    decheckallNeopassForm(readOrEdit, moduleName, state) {
      if (this.roleToEdit.rights.neopassForm[readOrEdit].all) {
        this.roleToEdit.rights.neopassForm[readOrEdit].all = state;
      }

      if (this.roleToEdit.rights.neopassForm[readOrEdit][moduleName].all) {
        this.roleToEdit.rights.neopassForm[readOrEdit][moduleName].all = state;
      }
    },
    /* END Boutons "Tout" dans le module formulaire Neopass (Ecriture / lecture / par module) */

    /* BEGIN Boutons "Tout" dans tous les modules (hors Neopass formulaire) */
    checkallModule(moduleName, state) {
      let permissions = this.listPermissions
        .filter((p) => p.module == moduleName && p.type == 'function')
        .map((p) => p.name);

      permissions.forEach((permission) => {
        this.roleToEdit.rights[moduleName][permission] = state;
      });

      if (
        [
          Constants.MODULE_FICHE_DE_POSTE,
          Constants.MODULE_REFERENTIEL_FORMATION,
        ].includes(moduleName)
      ) {
        this.roleToEdit.rights[moduleName].allPersonnal = state;
        this.roleToEdit.rights[moduleName].allShared = state;
      }

      //refresh the tab to take account the change in visualisation
      this.groupPermissionsDisplay = '';
      setTimeout(() => {
        this.groupPermissionsDisplay = moduleName;
      }, 50);
    },

    decheckallModule(moduleName, state) {
      if (this.roleToEdit.rights[moduleName].all) {
        this.roleToEdit.rights[moduleName].all = state;
      }
      if (
        [
          Constants.MODULE_FICHE_DE_POSTE,
          Constants.MODULE_REFERENTIEL_FORMATION,
        ].includes(moduleName) &&
        this.roleToEdit.rights[moduleName].allPersonnal
      ) {
        this.roleToEdit.rights[moduleName].allPersonnal = state;
      }

      if (
        [
          Constants.MODULE_FICHE_DE_POSTE,
          Constants.MODULE_REFERENTIEL_FORMATION,
        ].includes(moduleName) &&
        this.roleToEdit.rights[moduleName].allShared
      ) {
        this.roleToEdit.rights[moduleName].allShared = state;
      }
    },
    /* END Boutons "Tout" dans tous les modules (hors Neopass formulaire) */

    /* BEGIN Checkbox "Tout dans bibliothèque personnelle" et "Tout dans bibliothèque commune" dans le module Fiche de poste */
    checkAllFicheDePostePersonnalLibrary(state) {
      console.log('checkAllFicheDePostePersonnalLibrary');
      let permissions = this.listPermissions
        .filter(
          (p) =>
            p.module === Constants.PERMISSION_FICHE_DE_POSTE_PAGE &&
            p.name.includes('job_description_personnal') &&
            p.type === 'function'
        )
        .map((p) => p.name);
      permissions.forEach((permission) => {
        this.roleToEdit.rights[Constants.PERMISSION_FICHE_DE_POSTE_PAGE][
          permission
        ] = state;
      });
      this.groupPermissionsDisplay = '';
      setTimeout(() => {
        this.groupPermissionsDisplay = Constants.PERMISSION_FICHE_DE_POSTE_PAGE;
      }, 50);
    },

    decheckAllFicheDePostePersonnalLibrary(state) {
      console.log('decheckAllFicheDePostePersonnalLibrary');
      if (
        this.roleToEdit.rights[Constants.PERMISSION_FICHE_DE_POSTE_PAGE]
          .allPersonnal
      ) {
        this.roleToEdit.rights[
          Constants.PERMISSION_FICHE_DE_POSTE_PAGE
        ].allPersonnal = state;
      }
    },

    checkAllFicheDePosteSharedLibrary(state) {
      console.log('checkAllFicheDePosteSharedLibrary');
      let permissions = this.listPermissions
        .filter(
          (p) =>
            p.module == Constants.PERMISSION_FICHE_DE_POSTE_PAGE &&
            p.name.includes('job_description_shared') &&
            p.type == 'function'
        )
        .map((p) => p.name);

      permissions.forEach((permission) => {
        this.roleToEdit.rights[Constants.PERMISSION_FICHE_DE_POSTE_PAGE][
          permission
        ] = state;
      });
      this.groupPermissionsDisplay = '';
      setTimeout(() => {
        this.groupPermissionsDisplay = Constants.PERMISSION_FICHE_DE_POSTE_PAGE;
      }, 50);
    },

    decheckAllFicheDePosteSharedLibrary(state) {
      console.log('decheckAllFicheDePosteSharedLibrary');
      if (
        this.roleToEdit.rights[Constants.PERMISSION_FICHE_DE_POSTE_PAGE]
          .allShared
      ) {
        this.roleToEdit.rights[
          Constants.PERMISSION_FICHE_DE_POSTE_PAGE
        ].allShared = state;
      }
    },
    /* END Checkbox "Tout dans bibliothèque personnelle" et "Tout dans bibliothèque commune" dans le module Fiche de poste */

    /* BEGIN Checkbox "Tout dans bibliothèque personnelle" et "Tout dans bibliothèque commune" dans le module Référentiel de formation */
    checkAllReferentielFormationPersonnalLibrary(state) {
      console.log('checkAllReferentielFormationPersonnalLibrary');
      let permissions = this.listPermissions
        .filter(
          (p) =>
            p.module === Constants.PERMISSION_REFERENTIEL_FORMATION_PAGE &&
            p.name.includes('ref_formations_personnal') &&
            p.type === 'function'
        )
        .map((p) => p.name);
      permissions.forEach((permission) => {
        this.roleToEdit.rights[Constants.PERMISSION_REFERENTIEL_FORMATION_PAGE][
          permission
        ] = state;
      });
      this.groupPermissionsDisplay = '';
      setTimeout(() => {
        this.groupPermissionsDisplay =
          Constants.PERMISSION_REFERENTIEL_FORMATION_PAGE;
      }, 50);
    },

    decheckAllReferentielFormationPersonnalLibrary(state) {
      console.log('decheckAllReferentielFormationPersonnalLibrary');
      if (
        this.roleToEdit.rights[Constants.PERMISSION_REFERENTIEL_FORMATION_PAGE]
          .allPersonnal
      ) {
        this.roleToEdit.rights[
          Constants.PERMISSION_REFERENTIEL_FORMATION_PAGE
        ].allPersonnal = state;
      }
    },

    checkAllReferentielFormationSharedLibrary(state) {
      console.log('checkAllReferentielFormationSharedLibrary');
      let permissions = this.listPermissions
        .filter(
          (p) =>
            p.module == Constants.PERMISSION_REFERENTIEL_FORMATION_PAGE &&
            p.name.includes('ref_formations_shared') &&
            p.type == 'function'
        )
        .map((p) => p.name);

      permissions.forEach((permission) => {
        this.roleToEdit.rights[Constants.PERMISSION_REFERENTIEL_FORMATION_PAGE][
          permission
        ] = state;
      });
      this.groupPermissionsDisplay = '';
      setTimeout(() => {
        this.groupPermissionsDisplay =
          Constants.PERMISSION_REFERENTIEL_FORMATION_PAGE;
      }, 50);
    },

    decheckAllReferentielFormationSharedLibrary(state) {
      console.log('decheckAllReferentielFormationSharedLibrary');
      if (
        this.roleToEdit.rights[Constants.PERMISSION_REFERENTIEL_FORMATION_PAGE]
          .allShared
      ) {
        this.roleToEdit.rights[
          Constants.PERMISSION_REFERENTIEL_FORMATION_PAGE
        ].allShared = state;
      }
    },
    /* END Checkbox "Tout dans bibliothèque personnelle" et "Tout dans bibliothèque commune" dans le module Référentiel de formation */
  },
};
</script>
